import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { LabelForGhostInput } from 'components/atoms/label';

export const ActionItem = styled.div`
  min-width: 125px;
  padding-right: var(--spacing-05);
  position: relative;
  max-width: 176px;
  & ${Button} {
    min-width: 125px;
  }
`;

export const StyledLabelForGhostInput = styled(LabelForGhostInput)`
  padding-left: 0;
  margin-bottom: var(--spacing-02);
`;
